import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";
import CallsList from "./users/open-calls";
import MyApplications from "./users/applications";
import Application from "./users/application";
import AdminCalls from "./admin/calls/calls";
import CallsForms from "./admin/configurations/forms";

import "../../../styles/css/App.css";

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route 
        path={`${base}/open-calls`}>
        <CallsList />
      </Route>
      <Route 
        exact 
        path={`${base}/my-applications`}>
        <MyApplications />
      </Route>
      <Route
        exact
        path={`${base}/my-applications/:applicationId([0-9]+)`}
        render={(props) => (
          <Application applicationId={props.match.params.applicationId}/>
        )}
      />
      <Route path={`${base}/admin/calls`}>
        <AdminCalls />
      </Route>
      <Route path={`${base}/admin/forms`}>
        <CallsForms />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
